import { apiDate } from '@/platform/lib/utils';
import { useConfirmationStore } from '@/platform/stores/useConfirmationStore';
import {
    Button,
    Form,
    FormGroup,
    Header,
    Input,
    Message,
    Segment,
    SegmentContent,
    Textarea,
    Toggle,
} from '@/platform/ui';
import {
    Disclosure,
    DisclosureButton,
    DisclosurePanel,
} from '@headlessui/react';
import { ChevronDownIcon, PlusCircleIcon } from '@heroicons/react/24/outline';
import { useForm, usePage } from '@inertiajs/react';

const DgrForm = () => {
    const { employee } = usePage().props;
    const confirm = useConfirmationStore(state => state.confirm);
    const { data, setData, post, errors, processing, reset } = useForm({
        date: apiDate(new Date()),
        status: 0,
    });

    const handleSubmit = () => {
        confirm({
            title: 'Handmatige DGR-controle toevoegen?',
            description:
                'Deze controle kan andere services beïnvloeden. Weet je zeker dat je hem wilt toevoegen?',
            confirmLabel: 'Toevoegen',
            onConfirm: close => {
                post(
                    `/customers/${employee.customer_id}/employees/${employee.id}/dgr`,
                    {
                        reset: ['employee', 'navigation'],
                        preserveScroll: true,
                        preserveState: true,
                        onSuccess: () => reset(),
                        onFinish: close,
                    }
                );
            },
        });
    };

    return (
        <Segment>
            <Disclosure>
                <DisclosureButton className='group focus-visible:outline-primary-600 flex w-full items-center gap-3 rounded-xl px-6 py-4 text-left transition-colors hover:bg-gray-50 focus-visible:outline-2 focus-visible:outline-offset-2 data-open:rounded-b-none data-open:border-b data-open:border-gray-200'>
                    <PlusCircleIcon
                        aria-hidden='true'
                        className='text-primary-600 size-6 shrink-0'
                    />
                    <span className='min-w-0 flex-1'>
                        <span className='block text-base font-semibold text-gray-900'>
                            Handmatige controle toevoegen
                        </span>
                        <span className='block text-sm text-gray-500'>
                            Open het formulier om zelf een DGR-controle vast te
                            leggen.
                        </span>
                    </span>
                    <ChevronDownIcon
                        aria-hidden='true'
                        className='size-5 shrink-0 text-gray-400 transition-transform duration-200 group-hover:text-gray-600 group-data-open:rotate-180'
                    />
                </DisclosureButton>
                <DisclosurePanel
                    transition
                    className='origin-top transition duration-200 ease-out data-closed:-translate-y-2 data-closed:opacity-0'
                >
                    <SegmentContent>
                        <Message
                            variant='warning'
                            title='Belangrijk!'
                            content='Het toevoegen van een handmatige DGR-controle kan andere services beïnvloeden. Zorg ervoor dat je weet wat je doet!'
                            className='mb-4'
                        />
                        <Form onSubmit={handleSubmit}>
                            <FormGroup>
                                <Input
                                    type='date'
                                    label='Datum'
                                    value={data?.date || ''}
                                    onChange={event =>
                                        setData('date', event.target.value)
                                    }
                                    error={errors?.date}
                                />
                                <Toggle
                                    label='Is werknemer geregistreerd in Doelgroepregister?'
                                    checked={!!data?.status || false}
                                    onChange={checked =>
                                        setData('status', checked ? 1 : 0)
                                    }
                                    error={errors?.status}
                                />

                                <Header as='h6'>
                                    Gelieve een schermafbeelding of een reden te
                                    geven waarom deze Doelgroepregister controle
                                    is toegevoegd.
                                </Header>
                            </FormGroup>
                            <FormGroup inline equal>
                                <Textarea
                                    label='Reden'
                                    value={data?.reason || ''}
                                    onChange={event =>
                                        setData('reason', event.target.value)
                                    }
                                    error={errors?.reason}
                                />
                                <Input
                                    type='file'
                                    accept='image/*'
                                    label='Schermafbeelding'
                                    onChange={event =>
                                        setData(
                                            'screenshot',
                                            event.target.files[0]
                                        )
                                    }
                                    error={errors?.screenshot}
                                />
                            </FormGroup>
                            <div className='mt-4 flex items-center justify-end'>
                                <Button
                                    variant='primary'
                                    type='submit'
                                    loading={processing}
                                >
                                    Opslaan
                                </Button>
                            </div>
                        </Form>
                    </SegmentContent>
                </DisclosurePanel>
            </Disclosure>
        </Segment>
    );
};
export default DgrForm;
